import { render, staticRenderFns } from "./Restrictions.vue?vue&type=template&id=74f01c25"
import script from "./Restrictions.js?vue&type=script&lang=js&external"
export * from "./Restrictions.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports